import { combineReducers } from 'redux';
import WarehousesReducer from './warehousesReducer';

export default combineReducers({ WarehousesReducer});